// extracted by mini-css-extract-plugin
export var Big = "index-module--Big--38dd5";
export var ButtonGroup = "index-module--ButtonGroup--8c0e5";
export var Centered = "index-module--Centered--962d0";
export var Tiles = "index-module--Tiles--125e9";
export var WithMargin = "index-module--WithMargin--78305";